'use client'

import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

export function ScrollGrayscale({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.disconnect()
        }
      },
      { rootMargin: '-10% 0px' },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      className={className}
      style={{
        filter: isInView ? 'grayscale(0)' : 'grayscale(1)',
        transition: 'filter 1.2s ease-out',
      }}
    >
      {children}
    </div>
  )
}
